import { array2set } from './util';
import languagedefs from './languagedefs.json';


const LOCAL_API_ENDPOINT = "http://localhost:3000/"
const TEST_API_ENDPOINT = "https://devel-api.pentus.eu/"
const LIVE_API_ENDPOINT = "https://api.pentus.eu/"
const DOMAIN = "pentus.dk"

const REACT_APP_STAGE = process.env["REACT_APP_STAGE"]
const BRANCH = process.env["REACT_APP_BRANCH_NAME"];
const STAGE = process.env["REACT_APP_STAGE"]

const languages = languagedefs.map((x) => x.lang);
const language_set = array2set(languages);
const DEFAULT_LANGUAGE = languagedefs.find(l => l["default"]).lang || "da";
const ISMAINBRANCH = BRANCH === "main"

const CURRENT_LANG = process.env["REACT_APP_LANG"] || DEFAULT_LANGUAGE

export {
    LOCAL_API_ENDPOINT,
    TEST_API_ENDPOINT,
    LIVE_API_ENDPOINT,
    REACT_APP_STAGE,
    BRANCH,
    ISMAINBRANCH,
    DOMAIN,
    STAGE,
    CURRENT_LANG,
    DEFAULT_LANGUAGE,
    language_set,
    languages
}
